import React from "react";
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  flexRender,
} from "@tanstack/react-table";
import { getRandomNumber } from "../../../shared/utils/sharedUtils";
import { ArrowForwardIcon, ArrowBackIcon } from "../../../common/icon";

interface MyData {
  word: string;
  translation: string;
  pos: string;
  definition: string;
  sentence: string;
  audioPath: string;
  sentenceAudio: string;
  notes: null | string;
  noteId: null | string;
  defId: string;
  listId: string;
  posId: string;
  wordId: string;
  wordlist: string;
  isDeletable: boolean;
}

interface TableComponentProps {
  data: MyData[];
  columns: any[];
  Visibility: any;
}

const TableComponent: React.FC<TableComponentProps> = ({ data, columns, Visibility }) => {
  const table = useReactTable({
    data,
    columns,
    state: {
      columnVisibility: Visibility,
    },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    debugTable: true,
    debugHeaders: true,
    debugColumns: true,
  });

  return (
    <div className="p-2">
      <div className="h-2" />
      <table className="react-table-container">
        <thead className="react-table-header-container">
          {table.getHeaderGroups().map((headerGroup, index) => (
            <tr key={getRandomNumber(index)} className="react-table-header-row">
              {headerGroup.headers.map((header) => {
                return (
                  <th key={header.id} colSpan={header.colSpan} className="react-table-header-cell">
                    {header.isPlaceholder ? null : (
                      <div>{flexRender(header.column.columnDef.header, header.getContext())}</div>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody className="react-table-body-container">
          {table.getRowModel().rows.map((row, index) => {
            return (
              <tr key={getRandomNumber(index)} className="react-table-body-row">
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td key={cell.id} className="react-table-row-cell">
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  );
                })}
              </tr>
            );
          })}
          {table.getRowModel().rows.length === 0 && (
            <div className="no-wordlist-container">
              <p className="no-wordlist-message">No Data Found </p>
            </div>
          )}
        </tbody>
      </table>
      {data.length > 5 && (
        <div className="react-table-pagination">
          <button
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
            className="navigation-button"
            data-testid={"previousPage"}
          >
            <ArrowBackIcon />
          </button>{" "}
          <span className="pagination-details">
            Page{" "}
            <strong className="main-topic">
              {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
            </strong>{" "}
          </span>
          <button
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
            data-testid={"nextPage"}
            className="navigation-button"
          >
            <ArrowForwardIcon />
          </button>
        </div>
      )}
    </div>
  );
};

export default TableComponent;
